<template>
  <div class="container">

    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType" :params="{operationId: operationId}" :title="$t('bank.loan.info')" :sub-title-ope="operationName"
                  routeBack="OperationShow"/>
      <div class="row mx-0 ml-auto align-items-center">
        <button v-if="emprunt.id" class="show-action-btn edit mr-1" @click=clickOnEditBtn()>
          <pencil-icon size="18"/>
        </button>
        <button v-if="emprunt.id" class="show-action-btn delete"
                @click=clickOnDeleteBtn()>
          <trash-icon size="18"/>
        </button>
      </div>
    </div>

    <b-row v-if="!emprunt.id" align-h="center" class="row mx-0 mt-4">
      <div class="col-md-5 text-center">
        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
             style="max-height: 25%;">

        <div class="main-color-text-text bold-text level-two-title">
          {{ $t('operation.emprunt.emptyTitle') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.emprunt.emptySubtitle.first') }}
        </div>

        <b-button class="my-2" variant="primary" @click="clickOnCreateBtn">
          {{ $t('operation.emprunt.create') }}
        </b-button>
      </div>
    </b-row>

    <div v-else>
      <!--      <div class="white-card mr-0 p-3">-->
      <div class="white-card mr-0 p-3 mt-2">
        <div class="d-flex justify-content-between">
          <div class="level-two-title main-red-color bold-text mb-3">
            {{ $t('operation.General.infos') }}
          </div>
          <button class="show-action-btn edit btn-edit-emprunt" @click=clickOnEditBtn()>
            <pencil-icon size="18"/>
          </button>
        </div>
        <div class="row flex-row mx-0">
          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.amount') + ' : ' }}</div>
            <span> {{ Intl.NumberFormat().format(emprunt.totalAmount) + "€" }} </span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.startDate') + ' : ' }}</div>
            <span> {{ new Date(emprunt.contractDate).toLocaleDateString() }} </span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.durations') + ' : ' }}</div>
            <span> {{ emprunt.contractDurationInMonths + ' mois' }} </span>
          </div>

          <div class="col-md-3 row flex-row my-2"/>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.additional.folder') + ' : ' }}</div>
            <span> {{ convertToEuros(emprunt.dossierFee * 100) }}</span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.additional.hypotheque') + ' : ' }}</div>
            <span> {{ convertToEuros(emprunt.mortgageFee * 100) }}</span>
          </div>

          <div class="col-md-6 row flex-row my-2"/>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.apport.tresorerie') + ' : ' }}</div>
            <span> {{ convertToEuros(emprunt.treasuryContribution * 100) }}</span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.apport.investisseur') + ' : ' }}</div>
            <span> {{ convertToEuros(emprunt.investorContribution * 100) }}</span>
          </div>

          <div class="col-md-6 row flex-row my-2"/>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.interest.rate') + ' ' + this.an1 + ' : ' }}</div>
            <span> {{ (emprunt.interestRate + emprunt.euribor + emprunt.commitmentFee).toFixed(2) + '%' }}</span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.interest.rate') + ' ' + this.an2 + ' : ' }}</div>
            <span> {{ (emprunt.interestRate + emprunt.euribor2An + emprunt.commitmentFee).toFixed(2) + '%' }}</span>
          </div>

          <div class="col-md-3 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('bank.loan.interest.rate') + ' ' + this.an3 + ' : ' }}</div>
            <span> {{ (emprunt.interestRate + emprunt.euribor3An + emprunt.commitmentFee).toFixed(2) + '%' }}</span>
          </div>
        </div>
        <div class="level-two-title main-red-color bold-text mb-3 mt-4">
          {{ $t('bank.loan.apport.ordre') }}
        </div>
        <div class="row mx-0 mt-3 mb-3 justify-content-between">
          <div class="col-md-6 p-0 main-color bold-text"> {{ $t('bank.loan.apport.ordre.prelevements') }}</div>

        <div class="col-md-6 p-0 main-color-text bold-text"> {{ $t('bank.loan.apport.ordre.remboursements') }}</div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":1,\"name\":\"Emprunt\"},{\"id\":2,\"name\":\"Apport investisseurs\"},{\"id\":3,\"name\":\"Apport trésorerie\"}]"'>
            1. Emprunt<br/>
            2. Apport investisseurs<br/>
            3. Apport trésorerie<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":1,\"name\":\"Emprunt\"},{\"id\":3,\"name\":\"Apport trésorerie\"},{\"id\":2,\"name\":\"Apport investisseurs\"}]"'>
            1. Emprunt<br/>
            2. Apport trésorerie<br/>
            3. Apport investisseurs<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":2,\"name\":\"Apport investisseurs\"},{\"id\":1,\"name\":\"Emprunt\"},{\"id\":3,\"name\":\"Apport trésorerie\"}]"'>
            1. Apport investisseurs<br/>
            2. Emprunt<br/>
            3. Apport trésorerie<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":2,\"name\":\"Apport investisseurs\"},{\"id\":3,\"name\":\"Apport trésorerie\"},{\"id\":1,\"name\":\"Emprunt\"}]"'>
            1. Apport investisseurs<br/>
            2. Apport trésorerie<br/>
            3. Emprunt<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":3,\"name\":\"Apport trésorerie\"},{\"id\":2,\"name\":\"Apport investisseurs\"},{\"id\":1,\"name\":\"Emprunt\"}]"'>
            1. Apport trésorerie<br/>
            2. Apport investisseurs<br/>
            3. Emprunt<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordrePrelevements === "[{\"id\":3,\"name\":\"Apport trésorerie\"},{\"id\":1,\"name\":\"Emprunt\"},{\"id\":2,\"name\":\"Apport investisseurs\"}]"'>
            1. Apport trésorerie<br/>
            2. Emprunt<br/>
            3. Apport investisseurs<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordreRemboursements === "[{\"id\":2,\"name\":\"Investisseurs\"},{\"id\":1,\"name\":\"Emprunt\"}]"'>
            1. Investisseurs<br/>
            2. Emprunt<br/>
          </div>

          <div class="col-md-6 p-0 mt-2" v-if='emprunt.ordreRemboursements === "[{\"id\":1,\"name\":\"Emprunt\"},{\"id\":2,\"name\":\"Investisseurs\"}]"'>
            1. Emprunt<br/>
            2. Investisseurs<br/>
          </div>
        </div>
      </div>
      <div v-show="refundSell.length>0" class="white-card p-3 my-2 mt-2">
        <div class="level-two-title main-red-color bold-text mb-3">
          {{ $t('bank.history.refunds.sell') }}
        </div>
        <div v-for="(refund, index) in refundSell" :key="index">
          <div class="row align-items-center my-3">
            <div class="col-md-4">
              <div class="d-flex flex-column">
                <div class="bold-text"> {{ $t('Refund') }}</div>
                <div> {{ convertToEuros(refund.montant) }}</div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="d-flex flex-column">
                <div :class="{'main-green-color':refund.date<=new Date().getTime()}" class="bold-text">
                  {{ $t('interest.dateInterest') }}
                </div>
                <div> {{ convertDateToStr(refund.date) }}</div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="d-flex flex-column">
                <div class="bold-text"> {{ $t('Lot') }}</div>
                <b-link @click="goToOperation">
                  <div> {{ refund.operationLot.name }}</div>
                </b-link>
              </div>
            </div>
          </div>
          <div v-if="index < refundSell.length - 1">
            <div class="horizontal-line-grey"></div>
          </div>
        </div>
      </div>

      <div v-show="interestList.length>0" class="white-card p-3 my-2 mt-2">
        <div class="level-two-title main-red-color bold-text mb-3">
          {{ $t('bank.history.interest') }}
        </div>
        <div v-for="(interest, index) in interestList" :key="index">
          <div class="row align-items-center my-3">
            <div class="col-md-4">
              <div class="d-flex flex-column">
                <div class="bold-text"> {{ $t('user.Payment') }}</div>
                <div> {{ convertToEuros(interest.montant) }}</div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="d-flex flex-column">
                <div v-if="interest.date <= new Date().getTime()" class="main-green-color bold-text">
                  {{ $t('interest.dateInterestBank') }}
                </div>
                <div v-if="interest.date > new Date().getTime()" class="bold-text">
                  {{ $t('interest.dateInterestBankFuture') }}
                </div>
                <div> {{ convertDateToStr(interest.date) }}</div>
              </div>
            </div>

            <button class="ml-auto mr-3 show-action-btn edit btn-edit-emprunt" @click=clickOnEditInterest(interest)>
              <pencil-icon size="18"/>
            </button>
          </div>
          <div v-if="index < interestList.length - 1">
            <div class="horizontal-line-grey"></div>
          </div>
        </div>
      </div>
    </div>

    <Item-delete-modal
      id="bank-credit-delete-modal"
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selected-item-special-string="' associé à cette opération'"
      :selectedItem="emprunt"
      controllerName="bankCredit"
      itemSingularName="emprunt"
      itemSingularNameUpp="Emprunt"
      @didDeleteItem="didDeleteBankCredit()">
    </Item-delete-modal>

    <treasury-override-modal
      v-if="movement"
      :key="'tresomodal-' + treasuryModalKey"
      id="treasury-override-modal"
      @didCloseModal="fetchInterests"
      :movement="movement"/>

  </div>
</template>

<script>
import api from "../../../services/api";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import BackArrow from "../../../components/b122/BackArrow.vue";
import TreasuryOverrideModal from "../../treasury/TreasuryOverrideModal.vue";

export default {
  name: "OperationShowEmprunt",

  components: {
    TreasuryOverrideModal,
    BackArrow,
    ItemDeleteModal
  },

  async mounted() {
    this.isLoading = true
    await this.gotEmprunt()
    await this.getOperation()
    if (this.haveEmprunt && this.operationId) {
      await this.fetchEmprunt()
      await this.fetchAchatAndConstruction()
      if (this.emprunt.id) {
        await this.fetchRefundsSell()
        await this.fetchInterests()
      }
    }
    this.isLoading = false
  },


  data() {
    return {
      operationId: this.$route.params.operationId,
      operationDate: this.$route.params.operationDate,
      haveEmprunt: false,
      emprunt: {},
      an1: "",
      an2: "",
      an3: "",
      utilisationEmprunt: {},
      refundSell: [],
      interestList: [],
      isLoading: true,
      bilanType: null,
      operationName: null,
      movement: null,
      treasuryModalKey: 0,
    }
  },

  methods: {

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
          })
      }
    },


    async fetchAchatAndConstruction() {
      await api({
        method: 'GET',
        url: '/operation/getAchatAndConstruction/' + this.operationId,
      })
        .then((response) => {
          this.utilisationEmprunt = response.data

        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async gotEmprunt() {
      await api({
        method: 'GET',
        url: 'operation/' + this.operationId,
      })
        .then((response) => {
          this.haveEmprunt = response.data.emprunt
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchEmprunt() {
      await api({
        method: 'GET',
        url: 'bankCredit/' + this.operationId,
      })
        .then((response) => {
          this.emprunt = response.data
          this.an1 = new Date(this.emprunt.contractDate).getFullYear()
          this.an2 = new Date(this.emprunt.contractDate).getFullYear() + 1
          this.an3 = new Date(this.emprunt.contractDate).getFullYear() + 2
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('bank-credit-delete-modal')
    },

    didDeleteBankCredit() {
      this.emprunt = {}
    },

    clickOnEditBtn() {
      this.$router.push({
        name: "OperationEmpruntCreateEdit",
        params: {
          empruntId: this.emprunt.id,
          operationId: this.operationId,
          operationDate: this.operationDate
        }
      })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: "OperationEmpruntCreateEdit",
        params: {
          empruntId: this.emprunt.id,
          operationId: this.operationId,
          operationDate: this.operationDate
        }
      })
    },

    async fetchRefundsSell() {
      await api
        .get(`/bankCredit/getRemboursementForBankCredit/${this.emprunt.id}`)
        .then(response => {
          this.refundSell = response.data
        })
    },

    async fetchInterests() {
      await api
        .get(`/bankCredit/getInterestForBankCredit/${this.emprunt.id}`)
        .then(response => {
          this.interestList = response.data
        })
    },

    convertDateToStr(dateMillis) {
      return new Date(dateMillis).toLocaleDateString()
    },

    convertToEuros(value) {
      let euros = (value / 100).toFixed(2);
      return Intl.NumberFormat().format(euros) + " €"
    },


    goToOperation() {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 0
        }
      })
    },

    async clickOnEditInterest(interest) {
      let formData = new FormData()
      formData.append("objectUUID", interest.uuid)

      await api
        .post(`/treasury/getOverrideMovement`, formData)
        .then(response => {
          console.log(response.data)
          this.movement = response.data[0]
          this.treasuryModalKey++
          setTimeout(() => {
            this.$bvModal.show('treasury-override-modal')
          }, 100);

        })
    },

  }
}

</script>

<style scoped>

.card-emprunt {
  border: 2px solid var(--main-grey);
  padding: 15px;
  background-color: #FFFFFF;
}

.btn-edit-emprunt {
  height: 29px
}

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowEmprunt.vue